/**
 * @generated SignedSource<<8faebbdcf43f9ce6d4a2cdfe707fde80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RespondentResponses_respondent$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"RespondentResponses_ModalContent_respondent">;
  readonly " $fragmentType": "RespondentResponses_respondent";
};
export type RespondentResponses_respondent$key = {
  readonly " $data"?: RespondentResponses_respondent$data;
  readonly " $fragmentSpreads": FragmentRefs<"RespondentResponses_respondent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RespondentResponses_respondent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RespondentResponses_ModalContent_respondent"
    }
  ],
  "type": "RespondentNode",
  "abstractKey": null
};

(node as any).hash = "16ec4427a5d47347ec828580a14eae8d";

export default node;
